import { api } from "/src/config/api"
import socketIOClient from "socket.io-client"
import { useEffect } from "react"

const { pubsub: { url } } = api

console.log(`Creating socket client on ${url}`)

// connect
const socket = socketIOClient(url)

export function usePubSubListener(event, callback) {
  useEffect(() => {
    socket.on(event, callback)
    return () => socket.off(event, callback)
  }, [callback])
}
export default usePubSubListener